/**
 * Comparison operator for a single `FieldValidation.requiredWhen` comparison.
 * Values are a persisted config/wire slug.
 *
 * `Gt`/`Lt`/`Gte`/`Lte` coerce the sibling value to a number; `Equals` matches
 * the stringified value exactly (string equality); `Contains` is a substring
 * match; `IsEmpty`/`IsNotEmpty` test blankness (null/undefined/empty string)
 * and carry no comparison value.
 */
export enum HaulerRequiredWhenOpEnum {
  Gt = 'gt',
  Lt = 'lt',
  Gte = 'gte',
  Lte = 'lte',
  Equals = 'equals',
  Contains = 'contains',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
}
